import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from "react";
import { Button } from "../Button/Button.js";
import { Icon } from "../Icon/Icon.js";
export function Dialog({ open, title, children, onClose, confirmLabel = "Confirmer", cancelLabel = "Annuler", onConfirm, closeLabel = "Fermer", }) {
    const titleId = useId();
    const dialogRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const previous = document.activeElement;
        dialogRef.current?.focus();
        const onKeyDown = (event) => {
            if (event.key === "Escape")
                onClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            previous?.focus();
        };
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: "nbs-dialog-backdrop", role: "presentation", onClick: onClose, children: _jsxs("div", { ref: dialogRef, className: "nbs-dialog", role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, tabIndex: -1, onClick: (event) => event.stopPropagation(), children: [_jsx("button", { type: "button", className: "nbs-dialog__close", onClick: onClose, "aria-label": closeLabel, children: _jsx(Icon, { name: "x", size: "sm" }) }), _jsx("h2", { id: titleId, className: "nbs-dialog__title", children: title }), _jsx("div", { className: "nbs-dialog__body", children: children }), _jsxs("div", { className: "nbs-dialog__actions", children: [_jsx(Button, { variant: "secondary", onClick: onClose, children: cancelLabel }), onConfirm ? (_jsx(Button, { variant: "primary", onClick: () => {
                                onConfirm();
                                onClose();
                            }, children: confirmLabel })) : null] })] }) }));
}
//# sourceMappingURL=Dialog.js.map